export enum UserActionTypeBackupOptionsChanged {
  AddedBackupOptions = 'AddedBackupOptions',
  ChangedSpamTrash = 'ChangedSpamTrash',
  DeletedBackupOptions = 'DeletedBackupOptions',
  EditedBackupOptions = 'EditedBackupOptions'
}
